/* eslint-disable no-nested-ternary */
import React, {useEffect, useState} from 'react';
import InputContainer from 'components/BoxInputContainer';
import PasswordContainer from 'components/BoxPasswordContainer';
import validators from 'validator';
import {useDispatch, useSelector} from 'react-redux';
import {resetState} from 'actions/userActions';
import {makeSelectSignup} from 'reducers/selectors/userSelectors';
import {createUpdateTeam, updateStatus} from 'actions/teamActions';
import {makeSelectCreate} from 'reducers/selectors/teamSelector';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import {generatePassword} from 'utils/common';
import {ReactComponent as AddIcon} from 'assets/svgs/categories/add.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/categories/delete.svg';
import {ReactComponent as YearIcon} from 'assets/svgs/categories/year.svg';
import CheckIcon from 'assets/svgs/actions/confirm-delete-check.svg';
import FileUploadModal from './FileUploadModal';
import messages from './messages';
import './style.scss';

const AddTeamMember = ({
  onCancel,
  maxId,
  selectedTeam,
  updateBelow,
  deleteConfirm,
  setDeleteConfirm,
  setUpdating,
  onUpdated,
  setIsOpen,
}) => {
  const roles = useSelector((state) => state.roles.roles);
  const rolesOptions = [
    {value: true, label: 'Admin'},
    {value: false, label: 'Normal'},
  ];
  let teams = useSelector((state) => state.team.teams);
  const [teamOptions, setTeamOptions] = useState([]);
  const registerState = useSelector(makeSelectSignup());
  const teamSelector = useSelector(makeSelectCreate());
  const [selectLogo, setSelectLogo] = useState(false);

  const styles = (hide, width, size, background, color) => ({
    container: (base) => ({
      ...base,
      width: width || '100%',
    }),
    control: () => ({
      display: 'flex',
      borderRadius: 0,
      border: 'none',
      backgroundColor: background || undefined,
      color: color || undefined,
      minHeight: 50,
      borderLeft: '1px solid #d6d6d6',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: size === 'large' ? 12 : 10,
      display: hide ? 'none' : 'flex',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    valueContainer: (base) => ({
      ...base,
      height: 50,
      position: 'relative',
    }),
    singleValue: (base) => ({
      ...base,
      color: color || undefined,
      // display: 'flex',
      // height: 50,
      // justifyContent: 'center',
      // alignItems: 'center',
      // top: 0,
      // transform: 'translateY(0%)',
      textTransform: 'capitalize',
    }),
    menuList: (base) => ({
      ...base,
      textAlign: 'left',
      textTransform: 'capitalize',
    }),
    input: (base) => ({
      ...base,
      height: 20,
      padding: 0,
      marginTop: -10,
    }),
  });

  const getMaxId = () => {
    if (maxId === 0) {
      maxId = 1;
    }

    if (maxId < 10) {
      return `00${maxId}`;
    }
    if (maxId < 100) {
      return `0${maxId}`;
    }
    return maxId;
  };

  const dispatch = useDispatch();

  const [user, setUser] = useState({
    password: selectedTeam?.validToken || generatePassword(),
    firstName: '',
    lastName: '',
    email: '',
    memberType: 'MEMBER',
    isActive: true,
    roles: [],
    avatar: undefined,
    uniqueId: getMaxId(),
    teamName: '',
    userId: undefined,
  });

  const handleChange = (key, value) => {
    const newUser = {...user};
    newUser[key] = value;
    setUser(newUser);
  };

  const validations = {
    firstName: {
      validate: (value) => validators.isLength(value, {min: 2, max: 50}),
      error: `${messages.enterValid} First Name`,
    },
    lastName: {
      validate: (value) => validators.isLength(value, {min: 2, max: 50}),
      error: `${messages.enterValid} Last Name`,
    },
    teamName: {
      validate: (value) => validators.isLength(value, {min: 4, max: 50}),
      error: `${messages.enterValid} Last Name`,
    },
    email: {
      validate: (value) => validators.isEmail(value),
      error: `${messages.enterValid} Email`,
    },
    password: {
      validate: (value) =>
        selectedTeam || !value
          ? true
          : validators.isLength(value, {min: 8, max: 20}),
      error: `${messages.enterValid} Password`,
    },
    roles: {
      validate: (value) => value.length > 0,
      error: `Please select a role`,
    },
  };

  const [validationErrors, setValidationErrors] = useState({
    teamName: {
      isValid: false,
    },

    firstName: {
      isValid: false,
    },

    lastName: {
      isValid: false,
    },
    email: {
      isValid: false,
    },
    password: {
      isValid: false,
    },
    roles: {
      isValid: false,
    },
  });

  const validateField = (key, value) => {
    const validationForKey = validations[key];
    const newValidationErrors = {...validationErrors};

    if (!validationForKey.validate(value)) {
      newValidationErrors[key] = {
        isValid: false,
        error: validationForKey.error,
      };
      setValidationErrors(newValidationErrors);
    } else if (!validationErrors[key].isValid) {
      newValidationErrors[key] = {isValid: true};
      setValidationErrors(newValidationErrors);
    }
  };

  const checkForValidation = () => {
    let valid = true;
    const newValidationErrors = {...validationErrors};
    Object.keys(user).forEach((key) => {
      const validationForKey = validations[key];

      const value =
        key === 'roles' ? user[key] : user[key] ? user[key].toString() : '';

      if (validationForKey) {
        if (!validationForKey.validate(value)) {
          valid = false;

          newValidationErrors[key] = {
            isValid: false,
            error: validationForKey.error,
          };
        } else {
          newValidationErrors[key] = {
            isValid: true,
            error: '',
          };
        }
      }
      setValidationErrors(newValidationErrors);
    });

    return valid;
  };

  const onAddMember = async (event) => {
    if (event !== undefined && event.preventDefault) {
      event.preventDefault();
    }

    const isValid = checkForValidation();
    const fullObject = {
      ...user,
      roles: user.roles,
      teamName: user.teamName,
      username: user.email,
    };

    if (fullObject._id === 'new_user') {
      delete fullObject._id;
      delete fullObject.userId;
    }
    const updatedObject = {
      _id: user._id,
      userId: user.userId,
      teamName: user.teamName,
      username: user.email,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    };
    updatedObject.roles = user.roles.map((r) => r._id);
    if (fullObject._id === 'new_user') {
      delete updatedObject._id;
      delete updatedObject.userId;
    }
    if (user.password) updatedObject.password = user.password;
    updatedObject.logoId = user.logoId;
    updatedObject.avatar = user.avatar;
    if (!isValid) return;
    setUpdating(true);
    dispatch(createUpdateTeam(null, updatedObject));
    if (fullObject._id) {
      onUpdated({...fullObject, roles: user.roles});
    }
  };

  useEffect(() => {
    if (registerState.signupSuccess && registerState.createdUser) {
      onCancel();
      dispatch(resetState());
    }
  }, [registerState]);

  useEffect(() => {
    teams = teams.map((m) => ({
      label: m.name,
      value: m.name,
      // _id: m._id,
    }));
    setTeamOptions(teams);
    renderInitial();
  }, [teams]);

  const renderInitial = () => {
    if (selectedTeam) {
      const newUser = {
        ...selectedTeam,
        userId: selectedTeam._id,
        // password: selectedTeam.validToken || generatePassword(),
        teamName: selectedTeam.teamName,
      };

      setUser(newUser);
    }
  };

  useEffect(() => {
    renderInitial();
  }, [selectedTeam]);

  // useEffect(() => {
  //
  // }, [user]);

  useEffect(() => {
    if (teamSelector.createSuccess) {
      dispatch(updateStatus());
      onCancel();
      setTimeout(() => {
        updateBelow();
        setUpdating(false);
      }, 1000);
    }
  }, [teamSelector]);

  return (
    <>
      <div className="close-cat-row">
        <button
          type="button"
          className="btn-link"
          onClick={(e) => {
            e.preventDefault();
            if (user._id && user._id !== 'new_user') {
              setDeleteConfirm(true);
            } else {
              onCancel(true);
            }
          }}
        >
          <DeleteIcon />
        </button>
      </div>
      <table className="m-auto">
        <tbody>
          <tr className="empty-row">
            <td>
              <div className="edit-container d-flex flex-column mb-2">
                <InputContainer
                  type="text"
                  value={user.uniqueId}
                  placeholder={messages.id}
                  handleChange={(event) =>
                    handleChange('uniqueId', event.target.value)
                  }
                  inputClass="form-control"
                  disabled
                  className="dashed"
                />
              </div>

              <div className="edit-container d-flex flex-column mb-2">
                <div className="input-container  box-input-container">
                  <div className="d-flex align-items-center box h-100">
                    <div className="title px-3">Team</div>
                    <div className="input-container flex-grow-1">
                      <CreatableSelect
                        isClearable
                        menuPlacement="auto"
                        styles={styles(!!user.teamName)}
                        value={teamOptions.find(
                          (t) => t.value === user.teamName
                        )}
                        onChange={(newValue) => {
                          handleChange('teamName', newValue.value);
                        }}
                        placeholder=""
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        options={teamOptions}
                        onMenuClose={() => {
                          if (setIsOpen) setIsOpen(false);
                        }}
                        onMenuOpen={() => {
                          if (setIsOpen) setIsOpen(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="edit-container d-flex flex-column mb-0">
                <div className="input-container  box-input-container">
                  <div className="d-flex align-items-center box h-100">
                    <div className="title px-3">Role</div>
                    <div className="input-container flex-grow-1">
                      <Select
                        isMulti
                        isClearable
                        styles={styles(user.roles && user.roles.length > 0)}
                        menuPlacement="auto"
                        // value={roles.filter(r => user && user.roles.length>0 && user.roles.includes(r._id))}
                        value={user.roles}
                        onChange={(newValue) => {
                          if (newValue.find((r) => r.title === 'admin'))
                            newValue = [roles.find((r) => r.title === 'admin')];
                          handleChange('roles', newValue);
                        }}
                        placeholder=""
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option._id}
                        options={roles.filter(
                          (f) => f.title !== 'partner' && f.title !== 'reader'
                        )}
                        onMenuClose={() => {
                          if (setIsOpen) setIsOpen(false);
                        }}
                        onMenuOpen={() => {
                          if (setIsOpen) setIsOpen(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div
                aria-hidden
                className="upload-cat-img  border d-flex align-items-center"
                onClick={() => setSelectLogo(true)}
              >
                {user.avatar ? (
                  <div className="text-center">
                    <img
                      src={`${user.avatar}`}
                      className="mb-1 mt-3"
                      alt=""
                      width={80}
                    />
                    <div className="close-cat-im close-cat-row">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setUser({...user, avatar: ''});
                        }}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center">
                    <AddIcon className="mb-1 mt-3" alt="" />
                    <p>Avatar</p>
                  </div>
                )}
              </div>
            </td>
            <td>
              <div className="edit-container d-flex  mb-2">
                <div className="w-50 d-inline-block">
                  <InputContainer
                    type="text"
                    value={user.firstName}
                    placeholder="First"
                    handleChange={(event) =>
                      handleChange('firstName', event.target.value)
                    }
                    validate={(val) => validateField('firstName', val)}
                    validationError={validationErrors.firstName.error}
                    inputClass="form-control"
                    className=""
                  />
                </div>
                <div className="w-50 d-inline-block">
                  <InputContainer
                    type="text"
                    value={user.lastName}
                    placeholder=""
                    handleChange={(event) =>
                      handleChange('lastName', event.target.value)
                    }
                    validate={(val) => validateField('lastName', val)}
                    validationError={validationErrors.lastName.error}
                    inputClass="form-control"
                    className=""
                  />
                </div>
              </div>

              <div className="edit-container d-flex flex-column mb-2">
                <InputContainer
                  type="text"
                  value={user.email}
                  placeholder="Email"
                  handleChange={(event) =>
                    handleChange('email', event.target.value)
                  }
                  validate={(val) => validateField('email', val)}
                  validationError={validationErrors.email.error}
                  inputClass="form-control"
                  className=""
                />
              </div>

              <div className="edit-container d-flex flex-column ">
                <PasswordContainer
                  type="text"
                  value={user.password || ''}
                  placeholder={messages.password}
                  handleChange={(event) =>
                    handleChange('password', event.target.value)
                  }
                  icon={
                    <YearIcon
                      className="password-icon"
                      onClick={() => {
                        const password = generatePassword();
                        handleChange('password', password);
                      }}
                    />
                  }
                  validate={(val) => validateField('password', val)}
                  validationError={validationErrors.password.error}
                  inputClass="form-control"
                  className=""
                />
              </div>
            </td>
          </tr>
          {deleteConfirm && (
            <tr className="bg-gold">
              <td colSpan="3">
                <div className="d-flex text-alert align-items-center justify-content-between">
                  <p className="mb-0">
                    You want to delete this category with it translations for
                    sure?
                  </p>
                  <div className="d-flex">
                    <button
                      type="button"
                      className="mr-2 cat-delete"
                      onClick={() => {
                        setDeleteConfirm(null);
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="ml-auto cat-delete"
                      onClick={() => {
                        setUpdating(true);
                        const fullObject = {
                          _id: user._id,
                          userId: user.userId,
                          roles: user.roles,
                          teamName: user.teamName,
                          username: user.email,
                          isDeleted: true,
                          logoId: user.logoId,
                          avatar: user.avatar,
                        };
                        setDeleteConfirm(false);
                        dispatch(createUpdateTeam(null, fullObject));
                      }}
                    >
                      <img src={CheckIcon} alt="" className="mr-2" />
                      Confirm
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="add-cat-row">
        <button type="button" className="btn-link" onClick={onAddMember}>
          <AddIcon />
        </button>
      </div>
      {selectLogo && (
        <FileUploadModal
          type="users"
          typeKey="users"
          onSelect={(file) => {
            const newUser = {...user};
            newUser.logoId = file._id;
            newUser.avatar = file.liveURL;
            setUser(newUser);
            setSelectLogo(false);
          }}
          onClose={() => {
            setSelectLogo(false);
          }}
        />
      )}
    </>
  );
};
export default AddTeamMember;
